import { DefaultState } from 'store/types';

export const GET_ALL_BOOKINGS_REQUEST = 'GET_ALL_BOOKINGS_REQUEST';
export const GET_ALL_BOOKINGS_SUCCESS = 'GET_ALL_BOOKINGS_SUCCESS';
export const GET_ALL_BOOKINGS_FAILURE = 'GET_ALL_BOOKINGS_FAILURE';
export const GET_ALL_BOOKINGS_CLEAR = 'GET_ALL_BOOKINGS_CLEAR';

export interface GetAllBookingsData {
  location: {
    latitude: number;
    longitude: number;
  };
  miles: number;
  fromDate: Date;
  toDate?: Date;
  sorting: {
    id: string;
    order: string;
  }
}

export interface AllBookingsData {
  id: string;
  name: string;
  fromDate: string;
  toDate: string;
  gender: string;
  reservationProviderId: string;
  reservationProviderName: string;
  providerSendNotification: boolean;
  lodgingOptionName: string;
  lodgingOptionType: string;
  lodgingOptionLikesCount: number;
}

export type GetAllBookingsState = DefaultState & {
  contents?: AllBookingsData[];
};

interface GetAllBookingsRequest {
  type: typeof GET_ALL_BOOKINGS_REQUEST;
}

interface GetAllBookingsSuccess {
  type: typeof GET_ALL_BOOKINGS_SUCCESS,
  contents: AllBookingsData[];
}

interface GetAllBookingsFailure {
  type: typeof GET_ALL_BOOKINGS_FAILURE;
}

interface GetAllBookingsClear {
  type: typeof GET_ALL_BOOKINGS_CLEAR;
}

export type GetAllBookingsActionTypes = GetAllBookingsRequest | GetAllBookingsSuccess | GetAllBookingsFailure | GetAllBookingsClear;